/* eslint-disable ember/no-computed-properties-in-native-classes */
// Extending From
import Service from '@ember/service';
// Ember Imports
import { computed } from '@ember/object';
import { alias } from '@ember/object/computed';
// External Imports
import config from '@linc-technologies/linced-common/utils/config';

export default class EnvironmentService extends Service {
  // Attrs
  // config provides the ember environmental data.
  // This con be overridden via dependency injection for testing purposes.
  config = config;

  // name returns the current environment name that the app is running within.
  @alias('config.appEnvironment')
  name;

  // regionPrefix returns the dasherized url prefix to add if running in a
  // specific region.
  @alias('config.appRegionPrefix')
  regionPrefix;

  // version is defined based on the GitHub Actions build number. If
  // built locally will default to 'devel'.
  @alias('config.appVersion')
  version;

  // Methods
  // uriPrefix returns the environment prefix if building environmental URIs.
  @computed('name', 'regionPrefix')
  get uriPrefix() {
    let regionPrefix = this.regionPrefix || '';
    switch (this.name) {
      case 'devel':
      case 'development':
        return `${regionPrefix}dev-`;

      case 'local':
        return `${regionPrefix}local-`;

      case 'staging':
        return `${regionPrefix}staging-`;

      case 'beta':
        return `${regionPrefix}beta-`;

      default:
        return `${regionPrefix}`;
    }
  }
}
